import { getApiEndpoint } from "@amplio-common/api";
import { userNetworkDeviceDetailsTest as userNetworkDeviceDetailsTestPromise } from "@amplio-common/users/api";
import {
  osVersion,
  fullBrowserVersion,
  browserVersion,
  browserName,
  mobileVendor,
  osName,
  isMobileOnly,
  isTablet,
  isSmartTV,
  getUA,
  deviceType,
} from "react-device-detect";

export const getDownloadSpeed = (is_manual) => new Promise(((resolve) => {
  const download_speed = localStorage.getItem("download_speed");
  
  if (is_manual || !download_speed) {
    let endTime;
    const imageAddr = "https://upload.wikimedia.org/wikipedia/commons/2/2d/Snake_River_%285mb%29.jpg";
    const downloadSize = 5245329; //bytes
    const startTime = (new Date()).getTime();
    const download = new Image();
  
    const showResults = () => {
      const duration = (endTime - startTime) / 1000;
      const bitsLoaded = downloadSize * 8;
      const speedBps = (bitsLoaded / duration).toFixed(2);
      const result = Math.round(speedBps / (1024)); //kbps.
      !is_manual && localStorage.setItem("download_speed", result);
      setTimeout(() => {
        localStorage.removeItem("download_speed");
      }, 5000);
      resolve(result);
    };
  
    download.onload = () => {
      endTime = (new Date()).getTime();
      showResults(endTime, startTime);
    };
  
    download.onerror = () => {
      resolve("Error");
    };
  
  
    const cacheBuster = `?nnn=${startTime}`;
    download.src = imageAddr + cacheBuster;
  } else {
    localStorage.removeItem("download_speed");
    resolve(download_speed);
  }
}));
  
  
export const getUploadSpeed = (is_manual) => new Promise(((resolve) => {
  const upload_speed = localStorage.getItem("upload_speed");
  
  if (is_manual || !upload_speed) {
    localStorage.setItem("upload_speed", 1);
    let up_speed = 0;
  
    const getRandomString = (sizeInMb) => {
      const iterationsNum = sizeInMb * 1024 * 1024; //get byte count
      let result = "";
  
      for (let tempIndex = 0; tempIndex < iterationsNum; tempIndex += 1) {
        result += "A";
      }
      return result;
    };
  
    const url = `${getApiEndpoint("health/")}?cache=${Math.floor(Math.random() * 10000)}`; //prevent url cache
    const data = getRandomString(1); //1 meg POST size handled by all servers
    let speed = 0;
  
    const req = {
      headers: {},
      method: "POST",
      body: data,
    };
  
    const startTime = new Date();
    const calcSpeed = () => {
      speed = Math.round(1024 / ((new Date() - startTime) / 1000));
      up_speed === 0
        ? up_speed = speed
        : up_speed = Math.round((up_speed + speed) / 2);
      !is_manual && localStorage.setItem("upload_speed", up_speed);
      setTimeout(() => {
        localStorage.removeItem("upload_speed");
      }, 5000);
      resolve(up_speed);
    };
  
    fetch(url, req).then(() => {
      calcSpeed();
    }).catch(() => {
      calcSpeed();
    });
  } else {
    localStorage.removeItem("upload_speed");
    resolve(upload_speed);
  }
}));

  
export const getJSNumOperations = () => {
  const NUM_MS_FOR_OPERATIONS_CHECK = 20;

  let sysm = 0;
  const start = new Date().getTime();
  let end = new Date().getTime();
    
  while (end - start < NUM_MS_FOR_OPERATIONS_CHECK) {
    sysm += 1;
    end = new Date().getTime();
  }

  return sysm;
};

export const getJSResolveTime = () => new Promise((resolve) => {
  const start = new Date().getTime();
  setTimeout(() => resolve(new Date().getTime() - start), 0);
});

  
export const setUserNetworkDeviceDetails = async (currentUser) => {
  const upload_speed = await getUploadSpeed();
  const download_speed = await getDownloadSpeed();
  const js_resolve_ms = await getJSResolveTime();
  const js_num_ops = getJSNumOperations();

  const ua = getUA;
  const mobile_vendor = mobileVendor === "none" && (ua.toUpperCase().includes("XIAOMI") || ua.toUpperCase().includes(" MI ")) ? "XIAOMI" : mobileVendor;
  const deviceNetworkDetails = {
    user_id: currentUser.id,
    os_version: osVersion,
    full_browser_version: fullBrowserVersion,
    browser_version: browserVersion,
    browser_name: browserName,
    mobile_vendor,
    os_name: osName,
    is_mobile_only: isMobileOnly,
    is_tablet: isTablet,
    is_smart_tv: isSmartTV,
    upload_speed,
    download_speed,
    js_resolve_ms,
    js_num_ops,
  };
  
  userNetworkDeviceDetailsTestPromise(deviceNetworkDetails).catch(e => console.error(e));
  return (upload_speed >= 1000 && download_speed >= 5000);
};

export const getUserNetworkStats = async () => {
  const uploadSpeed = await getUploadSpeed();
  const downloadSpeed = await getDownloadSpeed();
  const js_resolve_ms = await getJSResolveTime();
  const js_num_ops = getJSNumOperations();

  const deviceNetworkDetails = {
    osVersion,
    browserVersion,
    browserName,
    osName,
    uploadSpeed,
    downloadSpeed,
    deviceType,
    js_resolve_ms,
    js_num_ops,
  };
  
  return deviceNetworkDetails;
};
  
